import React from 'react';
import Teacherday2024 from 'views/Teacherday2024';

const SchoolProgrampage = () => {
  return <Teacherday2024 />;
};

export default SchoolProgrampage;